var PastebinView = require('pastebinview');
var FileWrapper = require('filewrapper');
var FileInlineView = require('fileinlineview');
var Formatter = require('formatter');
var util = require('../../lib/util.es6');
var urlUtil = require('../../lib/url.es6');
var twitch = require('../../lib/twitch.es6');
var atPoint = require('atpoint');

var BufferLogContainerView = Backbone.View.extend({
    initialize: function (options, scroll) {
        // buffer can be a session
        this.buffer = options.buffer || this.model;
        this.scroll = scroll;
        this.formatter = new Formatter();
        
        this.missingReplyTargets = [];

        this.initDelayedLoads();
    },
    events: {
        'mousedown .joinPartGroup, .groupedJoinPart': 'mouseGroupedJoinPart',
        'mousemove .joinPartGroup, .groupedJoinPart': 'mouseGroupedJoinPart',
        'dblclick .joinPartGroup, .groupedJoinPart': 'mouseGroupedJoinPart',
        'click .joinPartGroup, .groupedJoinPart': 'mouseGroupedJoinPart',
        'buttonClick .joinPartGroup, .groupedJoinPart': 'mouseGroupedJoinPart',
        'mousedown .discoGroup, .groupedDisco': 'mouseGroupedDisco',
        'mousemove .discoGroup, .groupedDisco': 'mouseGroupedDisco',
        'dblclick .discoGroup, .groupedDisco': 'mouseGroupedDisco',
        'click .discoGroup, .groupedDisco': 'mouseGroupedDisco',
        'buttonClick .discoGroup, .groupedDisco': 'mouseGroupedDisco',
        'click a.embedClose, a.attachmentClose': 'clickEmbedClose',
        'buttonClick .embedClose, .attachmentClose': 'clickEmbedClose',
        'click div.gistwrap h1.gistwraptitle a.close': 'clickEmbedClose',
        'buttonClick div.paste .closeButton': 'clickPasteClose',
        'mouseenter span.date': 'hoverTimestamp',
        'mouseleave span.date': 'unhoverTimestamp',
        'mouseenter .messageActions': 'hoverMessageActions',
        'mouseleave .messageActions': 'unhoverMessageActions',
        'click span.date': 'clickDate',
        'click .react__add': 'clickReactAdd',
        'buttonClick .react__add': 'clickReactAdd',
        'buttonClick .deleteMessage': 'clickDeleteMessage',
        'buttonClick .editMessage': 'clickEditMessage',
        'buttonClick .reply__toggle': 'clickReplyToggle',
        'click .attachment__text-toggle': 'clickAttachmentTextToggle'
    },
    isSelected: function () {
        return this.buffer.isSelected();
    },
    getLine: function (message) {
        return this.$('#' + message.getEventId());
    },
    getMsgIdRow: function (msgid) {
        return this.$('.row[data-msgid="' + this.formatter.escapeQuerySelector(msgid) + '"]').last();
    },
    getReplyRows: function (msgid) {
        return this.$('.row[data-reply="' + this.formatter.escapeQuerySelector(msgid) + '"]');
    },
    handleClientTags: function (message, options) {
        if (!this.buffer.isChild()) {
            return;
        }
        if (!message.isClientTaggable()) {
            return;
        }
        var redact = message.getRedact() || message.getDelete();
        var edit = message.getEdit();
        var concat = message.getConcatTag();
        var reply = message.getReply();
        var reaction = message.getReaction();
        var unreaction = message.getUnreaction();
        var reactionImage = message.getReactionImage();
        if (redact) {
            if (this.buffer.isShowingDeletedMessages()) {
                return this.handleRedact(message, options, redact);
            } else {
                return this.handleRemove(message, options, redact);
            }
        } else if (edit) {
            return this.handleEdit(message, options, edit);
        } else if (concat) {
            return this.handleConcat(message, options, concat);
        } else if (reply) {
            if (reaction) {
                return this.handleReaction(message, options, reply, reaction, reactionImage);
            } else if (unreaction) {
                return this.handleUnreaction(message, options, reply, unreaction);
            } else {
                return this.handleReply(message, options, reply);
            }
        }
    },
    handleRemove: function (message, options, remove) {
        var row = this.getMsgIdRow(remove);
        if (!row.length) {
            this.missingReplyTargets.push(message);
            return;
        }
        var rowMessage = this.scroll.getMessageForRow(row);
        if (!rowMessage || !message.canDelete(rowMessage)) {
            // Invalid target, mark as processed
            return true;
        }
        var prevDate = row.prev('.dateChange');
        if (prevDate.length) {
            this.removeRow(prevDate, options);
        }
        if (row.hasClass('firstAuthor')) {
            var next = row.next();
            if (next.length && next.hasClass('sameAuthor')) {
                next.removeClass('sameAuthor');
                next.addClass('firstAuthor');
            }
        }
        rowMessage.remove(message);

        this.renderReplySummary(rowMessage);

        this.removeRow(row, options);
        return true;
    },
    handleRedact: function (message, options, redact) {
        var row = this.getMsgIdRow(redact);
        if (!row.length) {
            this.missingReplyTargets.push(message);
            return;
        }
        var rowMessage = this.scroll.getMessageForRow(row);
        if (!rowMessage || !message.canDelete(rowMessage)) {
            // Invalid target, mark as processed
            return true;
        }
        rowMessage.redact(message);

        var opts = _.extend({}, options, {actions: true});
        var rows = this.lineRenderer.render(rowMessage, opts).flush();
        this.replaceRow(row, rows, message, redact, options);
        return true;
    },
    handleEdit: function (message, options, edit) {
        var row = this.getMsgIdRow(edit);
        if (!row.length) {
            this.missingReplyTargets.push(message);
            return;
        }
        var rowMessage = this.scroll.getMessageForRow(row);
        if (!rowMessage || !rowMessage.hasSameAccount(message)) {
            // Invalid target, mark as processed
            return true;
        }
        if (!rowMessage.edit(message)) {
            // Already edited, remove any line we rendered and mark as processed
            this.removeRow(this.getLine(message), options);
            return true;
        }

        var opts = _.extend({}, options, {actions: true});
        var rows = this.lineRenderer.render(rowMessage, opts).flush();
        this.replaceRow(row, rows, message, edit, options);
        return true;
    },
    handleConcat: function (message, options, concat) {
        if (message.isAttachmentFallback()) {
            // Suppress fallback lines, mark as processed
            return true;
        }
        var row = this.getMsgIdRow(concat);
        if (!row.length) {
            // Target not in backlog, remove any line we rendered and continue
            this.removeRow(this.getLine(message), options);
            this.missingReplyTargets.push(message);
            return;
        }
        var rowMessage = this.scroll.getMessageForRow(row);
        if (!rowMessage || !rowMessage.hasSameAuthor(message)) {
            // Invalid target, mark as processed
            return true;
        }
        if (!rowMessage.concat(message)) {
            // Already concatted, remove any line we rendered and mark as processed
            this.removeRow(this.getLine(message), options);
            return true;
        }

        this.renderReplySummary(rowMessage);

        var opts = _.extend({}, options, {actions: true});
        var rows = this.lineRenderer.render(rowMessage, opts).flush();

        this.replaceRow(row, rows, message, concat, options);
        return true;
    },
    handleReply: function (message, options, reply) {
        if (!message.isReplyable() && !message.isTwitchReplyable()) {
            // Invalid target, mark as processed
            return true;
        }

        var line = this.getLine(message);
        line.toggleClass('reply--collapsed', this.buffer.isThreadCollapsedOverride(reply));
        line.toggleClass('reply--expanded', this.buffer.isThreadExpandedOverride(reply));

        var row = this.getMsgIdRow(reply);
        if (!row.length) {
            this.missingReplyTargets.push(message);
            return;
        }
        var rowMessage = this.scroll.getMessageForRow(row);
        if (!rowMessage || (!rowMessage.isReplyable() && !rowMessage.isTwitchReplyable())) {
            // Invalid target, mark as processed
            return true;
        }
        if (row.attr('data-reply') && row.attr('data-reply') != reply) {
            // Don't override existing reply data, this case happens
            // if a client tries to nest replies
            // Don't mark as processed
            return;
        }
        this.renderQuoteReply(message, line);
        this.renderReplySummary(message, reply, row);
        // Don't mark as processed, this isn't an empty message
    },
    renderReaction: function (row, reaction) {
        var prevEmojiIncludeTitle = emoji.include_title;
        var prevEmojiWithEmocodes = emoji.with_emocodes;
        emoji.include_title = false;
        emoji.with_emocodes = false;
        var rendered = this.formatter.renderEmoji(this.formatter.escapeText(reaction));
        emoji.include_title = prevEmojiIncludeTitle;
        emoji.with_emocodes = prevEmojiWithEmocodes;

        var prevEmojiTextMode = emoji.text_mode;
        emoji.text_mode = true;
        var titleText = emoji.strip_colons(this.formatter.renderEmoji(reaction));
        emoji.text_mode = prevEmojiTextMode;
        var toolTipBracket = ' (' + titleText + ')';

        var value = $('<span class="reaction__value">').html(rendered);
        var reactionSpan = row.find('.reaction').filter(function (i, r) {
            return $(r).find('.reaction__value').text() === value.text();
        }).first();

        return [rendered, toolTipBracket, value, reactionSpan];
    },
    handleUnreaction: function (message, options, reply, unreaction) {
        var row = this.getMsgIdRow(reply);
        if (!row.length) {
            this.missingReplyTargets.push(message);
            return;
        }
        var rowMessage = this.scroll.getMessageForRow(row);
        if (!rowMessage || !rowMessage.isReactable()) {
            // Invalid target, mark as processed
            return true;
        }
        var reactionContainer = row.find('.reactions');
        if (!reactionContainer.length) {
            // Target hasn't had any reactions yet
            this.missingReplyTargets.push(message);
            return;
        }
        
        var parts = this.renderReaction(row, unreaction);
        var rendered = parts[0];
        var toolTipBracket = parts[1];
        var value = parts[2];
        var reactionSpan = parts[3];

        if (!reactionSpan.length) {
            // Target hasn't had this reaction yet
            this.missingReplyTargets.push(message);
            return;
        }

        var reactors = _.without(reactionSpan.data('reactors'), message.getDisplayName());
        if (reactors.length) {
            reactionSpan.find('.reaction__count').remove();
            if (reactors.length > 1) {
                var countSpan = $('<span class="reaction__count">').text(reactors.length);
                reactionSpan.append(countSpan);
            }
            reactionSpan
                .attr('title', this.formatter.listSentence(reactors) + toolTipBracket)
                .data({
                    reactors: reactors
                });
        } else {
            reactionSpan.remove();
        }
        if (!reactionContainer.find('.reaction:not(.react__add)').length) {
            reactionContainer.remove();
        }

        // This gets read in flushBuffer to determine scroll updating
        options.reaction = true;
        return true;
    },
    handleReaction: function (message, options, reply, reaction, reactionImage) {
        var row = this.getMsgIdRow(reply);
        if (!row.length) {
            this.missingReplyTargets.push(message);
            return;
        }
        var rowMessage = this.scroll.getMessageForRow(row);
        if (!rowMessage || !rowMessage.isReactable()) {
            // Invalid target, mark as processed
            return true;
        }
        var reactionContainer = row.find('.reactions');
        var reactionAdd;
        if (!reactionContainer.length) {
            reactionContainer = $('<span class="reactions">');
            reactionAdd = $('<span class="reaction react__add reaction--active" role="button" title="Add a reaction" aria-label="Add a reaction" aria-haspopup="true" aria-expanded="false" aria-controls="emojiContextMenu" tabindex="0">')
                .append($('<span class="reaction__value">').html('<i class="fa fa-plus-circle">'));
            reactionContainer.append(reactionAdd);
            var toolTip = row.find('.reply__tooltip');
            if (toolTip.length) {
                toolTip.after(reactionContainer);
            } else {
                row.append(reactionContainer);
            }
        } else {
            reactionAdd = reactionContainer.find('.react__add');
        }
        
        var parts = this.renderReaction(row, reaction);
        var rendered = parts[0];
        var toolTipBracket = parts[1];
        var value = parts[2];
        var reactionSpan = parts[3];

        var nick = message.getDisplayName();

        if (reactionSpan.length) {
            var reactors = _.unique(reactionSpan.data('reactors').concat([nick]));
            reactionSpan.find('.reaction__count').remove();
            if (reactors.length > 1) {
                var countSpan = $('<span class="reaction__count">').text(reactors.length);
                reactionSpan.append(countSpan);
            }
            reactionSpan
                .attr('title', this.formatter.listSentence(reactors) + toolTipBracket)
                .data({
                    reactors: reactors
                });
        } else {
            reactionSpan = $('<span class="reaction reaction--active">')
                .attr('title', nick + toolTipBracket)
                .data({
                    reactors: [nick],
                    reaction: reaction,
                    msgid: reply,
                    cid: message.getCid(),
                    bid: message.bid()
                })
                .append(value);
            if (reactionImage) {
                var img = $('<img class="reaction__image">').attr({
                    src: reactionImage,
                    alt: nick + toolTipBracket
                });
                reactionSpan.addClass('reaction--image');
                reactionSpan.append(img);
            }
            reactionSpan.insertBefore(reactionAdd);
        }
        if (message.isSelf()) {
            reactionSpan.data('self', true);
            reactionSpan.addClass('reaction--self');
            reactionSpan.removeClass('reaction--active');
            reactionSpan.removeAttr('role');
        } else {
            reactionSpan.attr('role', 'button');
        }
        // This gets read in flushBuffer to determine scroll updating
        options.reaction = true;
        return true;
    },
    renderQuoteReply: function (message, line) {
        var quoteReplyString = message.quoteReplyString();
        if (quoteReplyString) {
            var quoteReply = '<span class="link">';
            quoteReply += this.formatter.escapeText(quoteReplyString);
            quoteReply += '</span>';
            line.find('.reply__quote').html(quoteReply);
        }
    },
    renderReplySummary: function (message, reply, row) {
        reply = reply || message.getReply();
        row = row || this.getMsgIdRow(reply);
        if (!row.length) {
            return;
        }
        var replyTooltip = row.find('.reply__tooltip');
        var replySummary = row.find('.reply__summary');
        var replies = message.getReplies();
        if (replies.length) {
            if (!replyTooltip.length) {
                replySummary = $('<span class="reply__summary">');
                row.addClass('reply reply_' + this.formatter.getReplyColorIndex(reply));
                if (this.buffer.isThreadCollapsedOverride(reply)) {
                    row.addClass('reply__top--collapsed');
                }
                if (this.buffer.isThreadExpandedOverride(reply)) {
                    row.addClass('reply__top--expanded');
                }
                row.attr('data-reply', reply);

                replyTooltip = $('<span class="reply__tooltip">');
                row.append(replyTooltip);
                row.append(replySummary);
            }
            var repliers = _.unique(_.invoke(replies, 'getDisplayName'));
            var replyText = replies.length + ' ' + this.formatter.pluralise(replies.length, 'reply', 'replies');
            replySummary.html('<i class="fa fa-comment"></i>');
            replySummary.append($('<span class="link">').text(replyText + ': ' + this.formatter.listSentence(repliers)));
            replyTooltip.text(replyText);
            return true;
        } else {
            row.removeClass('reply reply_' + this.formatter.getReplyColorIndex(reply));
            row.removeAttr('data-reply');
            replyTooltip.remove();
            replySummary.remove();
        }
    },
    renderMessage: function (message, options) {
        options = options || {};
        var rows = this.lineRenderer.render(message, options).flush();
        if (!rows.length) {
            return $();
        }
        var classNames = [];
        if (this.lineRenderer.endedConcat) {
            _.each(this.lineRenderer.endedConcat, function (m) {
                if (!m.equals(message)) {
                    this.handleClientTags(m, options);
                }
            }, this);
        } else if (this.lineRenderer.createdJoinPart || this.lineRenderer.createdDiscoGroup) {
            var lastMessageRow = options.lastMessageRow;
            if (!lastMessageRow) {
                lastMessageRow = this.$('.messageRow:last');
            }
            if (options.batch) {
                options.toExclude = options.toExclude.add(lastMessageRow);
            }
            lastMessageRow.remove();
        } else if (this.lineRenderer.joinPart) {
            var lastJoinPartHeading = options.lastJoinPartHeading;
            if (!lastJoinPartHeading) {
                lastJoinPartHeading = this.$('.groupedJoinPart:last');
            }
            if (lastJoinPartHeading.is('.expanded') || this.lineRenderer.joinPart.expanded) {
                classNames.push('expanded');
            }
            if (options.batch) {
                options.toExclude = options.toExclude.add(lastJoinPartHeading)
                    .add(lastJoinPartHeading.next('.joinPartGroup'));
            }
            lastJoinPartHeading.next('.joinPartGroup').remove();
            lastJoinPartHeading.remove();
        } else if (this.lineRenderer.discoGroup) {
            var lastDiscoHeading = options.lastDiscoHeading;
            if (!lastDiscoHeading) {
                lastDiscoHeading = this.$('.groupedDisco:last');
            }
            if (lastDiscoHeading.is('.expanded') || this.lineRenderer.discoGroup.expanded) {
                classNames.push('expanded');
            }
            if (options.batch) {
                options.toExclude = options.toExclude.add(lastDiscoHeading)
                    .add(lastDiscoHeading.next('.discoGroup'))
                    .add(lastDiscoHeading.next('.groupedDiscoPart'));
            }
            lastDiscoHeading.next('.discoGroup').remove();
            lastDiscoHeading.next('.groupedDiscoPart').remove();
            lastDiscoHeading.remove();
        }
        
        if (message.get('entities')
            && message.get('entities').files
            && message.get('entities').files[0]
            && message.get('entities').files[0].url
        ) {
            classNames.push('fileLoading');
        }
        if (options.batch) {
            return this.prepareFilterClassNames(rows, classNames);
        } else {
            return this.append(rows, classNames, message);
        }
    },
    append: function (rows, classNames, message) {
        var els = this.prepareInsertion(rows, classNames);
        $(this.el).append(els);
        var reqid;
        if (message) {
            reqid = message.get('reqid');
        }
        this.postInsertion(els, false, reqid);
        return els;
    },
    removeRow: function (row, options) {
        if (options && options.batch) {
            options.toExclude = options.toExclude.add(row);
            options.toRemove = options.toRemove.add(row);
        } else {
            row.remove();
        }
    },
    replaceRow: function (row, rows, message, messageId, options) {
        this.removeRow(this.getLine(message), options);

        options = options || {};
        var els = this.prepareFilterClassNames(rows);
        if (options.batch) {
            if (message.get('reqid')) {
                if (options.reqidMap[message.get('reqid')]) {
                    els = options.reqidMap[message.get('reqid')].add(els);
                }
                options.reqidMap[message.get('reqid')] = els;
            } else {
                options.nonReqidEls = options.nonReqidEls.add(els);
            }
            options.toExclude = options.toExclude.add(row);
            options.toReplace[messageId] = els;
        } else {
            this.prepareEmbeds(els);
            this.doReplaceRow(row, els, messageId);
            this.postInsertion(els);
        }
    },
    doReplaceRow: function (row, els, messageId) {
        var reply = row.attr('data-reply');
        var reactionContainer = row.find('.reactions').clone(true);
        var replyToolTip = row.find('.reply__tooltip').clone(true);
        var replySummary = row.find('.reply__summary').clone(true);
        row.replaceWith(els);
        var newRow = this.getMsgIdRow(messageId);
        if (reply) {
            newRow.addClass('reply reply_' + this.formatter.getReplyColorIndex(reply));
            newRow.attr('data-reply', reply);
        }
        if (reactionContainer.length) {
            newRow.append(reactionContainer);
        }
        if (replyToolTip.length) {
            newRow.append(replyToolTip);
        }
        if (replySummary.length) {
            newRow.append(replySummary);
        }
    },
    prepareInsertion: function (rows, classNames, initial) {
        var els = this.prepareFilterClassNames(rows, classNames);
        this.prepareEmbeds(els, initial);
        return els;
    },
    postInsertion: function (els, initial, reqid) {
        this.loadFiles(els, initial, reqid);
    },
    prepareFilterClassNames: function (rows, classNames) {
        // Filter empty items
        var els = $(_.filter($.makeArray(rows), _.identity).join(''));
        if (classNames && classNames.length) {
            els.addClass(classNames.join(' '));
        }
        return els;
    },
    processConsecutiveQuotes: function (els, initial) {
        els.find('blockquote.quote + span.g + blockquote.quote').each(function (i, q) {
            // Adjacent sibling selector ignores non-elment nodes, only add this class
            // if there isn't e.g. a text node in between
            if ($(q.previousSibling.previousSibling).is('blockquote.quote')) {
                $(q).addClass('quote--consecutive');
            }
        });
    },
    prepareEmbeds: function (els, initial) {
        this.processConsecutiveQuotes(els, initial);
        this.loadTwitchBadges(els, initial);
        if (this.buffer.inlineImagesAllowed()) {
            this.inlineImages(els, initial);
        } else {
            this.loadTwitchEmotes(els, initial);
        }
        this.loadAttachmentSnippets(els, initial);
        if (this.buffer.inlinePastesAllowed()) {
            this.loadPastes(els, initial);
            this.loadGists(els, initial);
            // Pastebin.com
            this.loadEmbedIframes(els, initial);
        }
        if (this.buffer.inlineSocialMediaAllowed()) {
            this.loadTweets(els, initial);
        }
        if (this.buffer.inlineMastodonAllowed()) {
            this.loadMastodon(els, initial);
        }
        if (this.buffer.inlineBskyAllowed()) {
            this.loadBsky(els, initial);
        }
        if (this.buffer.inlineRedditAllowed()) {
            this.loadReddit(els, initial);
        }
    },


    // Element at position
    getRowAtPosition: function (x, y) {
        var targets = atPoint(x, y, 'div.row', 'div.scroll, div.timecell');
        var target = targets.pop();
        if (!target) {
            return $();
        }
        return $(target).closest('div.row');
    },
    getRowAtTopOfScroll: function () {
        var clientRect = this.scroll.getRect();
        var offsets = this.scroll.rowPositionOffsets();
        var y = clientRect.top + offsets.y;
        var x = clientRect.left + offsets.x;
        var initialRow = this.getRowAtPosition(Math.ceil(x), Math.ceil(y));
        var row = initialRow;
        
        // If the row isn't fully visible in the viewport the scroll, use the next row
        if (row.length) {
            var delta = y - row.offset().top;
            // var rowHeight = row.outerHeight();
            // var halfHeight = rowHeight / 2;
            // if (delta > halfHeight) { // alternative if we want to allow half of the row to be invisible
            if (delta > 1) {
                var previousRow;
                do {
                    previousRow = row;
                    row = row.next();
                    if (row.is('.joinPartGroup')) {
                        row = row.find('.row:first-child');
                    } else if (!row.length && previousRow.is('.joinPartGroup .row')) {
                        row = previousRow.closest('.joinPartGroup').next();
                    }
                } while (row.length && !row.is(':visible'));
                if (!row.length || !row.is(':visible')) {
                    row = initialRow;
                }
            }
        }
        return [row, initialRow];
    },
    getRowAtBottomOfScroll: function () {
        var clientRect = this.scroll.getRect();
        var x = clientRect.left;
        var y = clientRect.bottom - 2;
        var initialRow = this.getRowAtPosition(Math.ceil(x), Math.floor(y));
        var row = initialRow;
        
        // If more than half the row is off the bottom of the viewport, use the previous row
        if (row.length) {
            var delta = y - row.offset().top;
            var rowHeight = row.outerHeight();
            var halfHeight = rowHeight / 2;
            // if (delta < rowHeight - 1) { // alternative if we want to make sure the full row is visible
            if (delta < halfHeight) {
                var previousRow;
                do {
                    previousRow = row;
                    row = row.prev();
                    if (row.is('.joinPartGroup')) {
                        row = row.find('.row:last-child');
                    } else if (!row.length && previousRow.is('.joinPartGroup .row')) {
                        row = previousRow.closest('.joinPartGroup').prev();
                    }
                } while (row.length && !row.is(':visible'));
                if (!row.length || !row.is(':visible')) {
                    row = initialRow;
                }
            }
        }
        return [row, initialRow];
    },
    
    resetStickyAuthorRow: function () {
        if (this.stickyAuthor) {
            this.stickyAuthor.removeClass('firstAuthor--sticky');
            this.stickyAuthor = null;
        }
    },
    setStickyAuthorRow: function (row) {
        if (this.stickyAuthor && this.stickyAuthor != row) {
            this.resetStickyAuthorRow();
        }
        this.stickyAuthor = row;
        row.addClass('firstAuthor--sticky');
    },
    setStickyAuthor: function (rows) {
        if (!this.buffer.avatarsEnabled() || !this.buffer.multiline()) {
            // Not the right layout
            return this.resetStickyAuthorRow();
        }
        
        var actualTop = rows[1];
        if (!actualTop.is('.sameAuthor, .firstAuthor')) {
            // Not the right message at top
            return this.resetStickyAuthorRow();
        }
        
        var firstAuthor;
        if (actualTop.is('.sameAuthor')) {
            firstAuthor = actualTop
                .prevAll('.firstAuthor:first');
        } else {
            firstAuthor = actualTop;
        }
        
        if (!firstAuthor.length) {
            // Can be missing a first author if the
            // backlog has been trimmed
            return this.resetStickyAuthorRow();
        }
        
        // Keep these synced with CSS
        var avatarHeight = 32;
        var avatarOffset = 8;
        
        var avatarBottom = avatarHeight + avatarOffset;
        
        var firstAvatar = firstAuthor.find('.avatar');
        var firstAuthorRect = firstAuthor[0].getBoundingClientRect();
        var avatarTop = firstAuthorRect.top + avatarOffset;
        var clientRect = this.scroll.getRect();
        var offsets = this.scroll.rowPositionOffsets();
        var scrollTop = clientRect.top + offsets.y;
        if (avatarTop >= scrollTop) {
            // Top avatar is already fully visible
            return this.resetStickyAuthorRow();
        }
        
        var lastAuthor = firstAuthor.nextUntil(':not(.sameAuthor)', '.messageRow').last();
        var lastAuthorRect;
        if (lastAuthor.length) {
            lastAuthorRect = lastAuthor[0].getBoundingClientRect();
        } else {
            lastAuthor = firstAuthor;
            lastAuthorRect = firstAuthorRect;
        }
        var lastTop = lastAuthorRect.bottom - avatarBottom;
        if (lastTop <= avatarTop) {
            // Top avatar is already visible enough
            return this.resetStickyAuthorRow();
        }
        
        var top = Math.min(lastTop - clientRect.top, offsets.y);
        this.setStickyAuthorRow(firstAuthor);
        var eid = firstAuthor.data('eid');
        return [firstAvatar, top, eid];
    },

    hoverTimestamp: function (e) {
        $(e.target).closest('.row').addClass('timestampHighlight');
    },
    unhoverTimestamp: function (e) {
        $(e.target).closest('.row').removeClass('timestampHighlight');
    },
    hoverMessageActions: function (e) {
        $(e.target).closest('.row').addClass('messageActionHighlight');
    },
    unhoverMessageActions: function (e) {
        $(e.target).closest('.row').removeClass('messageActionHighlight');
    },
    clickDate: function (e) {
        var row = $(e.currentTarget).closest('.row');
        var msg = this.buffer.getMessage(row.data('eid'));
        this.buffer.session.trigger('clickedMessageDate', msg);
        return false;
    },
    clickDeleteMessage: function (e) {
        var target = $(e.currentTarget);
        var row = target.closest('.row');
        var msg = this.buffer.getMessage(row.data('eid'));
        this.buffer.trigger('deleteMessageConfirm', msg);
        return false;
    },
    clickEditMessage: function (e) {
        var target = $(e.currentTarget);
        var row = target.closest('.row');
        var msg = this.buffer.getMessage(row.data('eid'));
        this.buffer.trigger('editMessagePrompt', msg);
        return false;
    },
    clickReactAdd: function (e) {
        var target = $(e.currentTarget);
        var row = target.closest('.row');
        var msg = this.buffer.getMessage(row.data('eid'));
        this.buffer.session.trigger('clickedMessageReactAdd', msg, target);
        return false;
    },
    clickReplyToggle: function (e) {
        var target = $(e.currentTarget);
        var row = target.closest('.row');
        var reply = row.data('reply');
        var topRow = this.getMsgIdRow(reply);
        var rows = this.getReplyRows(reply).not(topRow);
        var tooltip = topRow.find('.reply__tooltip');

        var collapsed = this.buffer.isThreadCollapsedOverride(reply);
        var expanded = this.buffer.isThreadExpandedOverride(reply);
        var bufCollapsed = this.buffer.isCollapsingReplies();
        if (bufCollapsed) {
            // All buffer threads collapsed
            // Set expanded status
            this.buffer.setThreadExpandedOverride(reply, !expanded);
            // Remove unneeded overrides
            topRow.removeClass('reply__top--collapsed');
            rows.removeClass('reply--collapsed');
            // Set class
            topRow.toggleClass('reply__top--expanded', !expanded);
            rows.toggleClass('reply--expanded', !expanded);
        } else {
            // All buffer threads expanded (default)
            // Set collapsed status
            this.buffer.setThreadCollapsedOverride(reply, !collapsed);
            // Remove unneeded overrides
            topRow.removeClass('reply__top--expanded');
            rows.removeClass('reply--expanded');
            // Set class
            topRow.toggleClass('reply__top--collapsed', !collapsed);
            rows.toggleClass('reply--collapsed', !collapsed);
        }
        this.scroll.onChange();
        return false;
    },
    clickAttachmentTextToggle: function (e) {
        $(e.currentTarget).closest('.attachment__text').toggleClass('attachment__text--more');
        return false;
    },
    mouseGroupedJoinPart: function (e) {
        if (!this.buffer.isCollapsingJoinPart()) {
            return;
        }
        var target = $(e.currentTarget);
        var group, heading;
        if (target.is('.joinPartGroup')) { 
            group = target;
            heading = group.prev('.groupedJoinPart');
        } else {
            heading = target;
            group = heading.next('.joinPartGroup');
        }
        this.mouseGrouped(e, group, heading);
    },
    mouseGroupedDisco: function (e) {
        if (this.buffer.isServerLog() && !this.buffer.isCollapsingDisconnects()) {
            return;
        }
        var target = $(e.currentTarget);
        var group, heading;
        if (target.is('.discoGroup')) { 
            group = target;
            heading = group.prev('.groupedDisco');
        } else {
            heading = target;
            group = heading.next('.discoGroup');
        }
        this.mouseGrouped(e, group, heading);
    },
    mouseGrouped: function (e, group, heading) {
        switch (e.type) {
        case 'buttonClick':
            this.toggleGrouped(e, group, heading);
            break;
        case 'mousedown':
            group.data('mousecoords', [e.clientX, e.clientY, util.ts()]);
            group.removeData('mousemove');
            group.removeData('dblclick');
            break;
        case 'mousemove':
            group.data('mousemove', true);
            break;
        case 'dblclick':
            group.data('dblclick', true);
            break;
        case 'click':
            var coords = group.data('mousecoords');
            var mousemove = group.data('mousemove');
            group.removeData('mousecoords');
            group.removeData('mousemove');
            group.removeData('dblclick');
            
            var dblclickDelay = 200;
            
            if (mousemove) {
                var diffs = [
                    e.clientX - coords[0],
                    e.clientY - coords[1],
                    util.ts() - coords[2]
                ];
                if (diffs[0] !== 0 || diffs[1] !== 0 || diffs[2] > dblclickDelay) {
                    debug.log('canceling toggle due to move, diffs:', diffs);
                    return;
                }
            }
            setTimeout(_.bind(function () {
                if (!group.data('dblclick')) {
                    this.toggleGrouped(e, group, heading);
                } else {
                    debug.log('canceling toggle due to dblclick');
                }
            }, this), dblclickDelay);
            
            break;
        }
    },
    toggleGrouped: function (e, group, heading) {
        if ($(e.target).is('a, button')) {
            return;
        }
        heading.toggleClass('expanded');
        var expanded = heading.hasClass('expanded');
        heading.attr('aria-expanded', String(expanded));
        group.animate({
            "height": 'toggle',
            "marginTop": 'toggle',
            "marginBottom": 'toggle',
            "paddingTop": 'toggle',
            "paddingBottom": 'toggle'
        }, {
            duration: 'fast',
            step: _.bind(function () {
                this.scroll.onChange();
            }, this),
            complete: function () {
                group.toggleClass('expanded');
                group.css('display', '');
            }
        });
    },

    inlineImages: function (els, initial) {
        this.triggerImagesLoaded(els, initial);
        this.loadEmbedIframes(els, initial);
        this.loadFlickr(els, initial);
        this.loadSoundCloud(els, initial);
        this.loadStreamableCom(els, initial);
        this.loadInstagram(els, initial);
        this.loadPinterest(els, initial);
        this.loadXKCD(els, initial);
        this.loadImgur(els, initial);
        this.loadGfyCat(els, initial);
        this.loadWiki(els, initial);
    },
    loadMedia: function (els, selector, onLoad, initial, reqid) {
        var boundOnLoad = _.bind(onLoad, this, els, initial, reqid);
        this.registerDelayedLoad(els, selector, boundOnLoad);
        return boundOnLoad;
    },
    initDelayedLoads: function () {
        this.delayedLoads = {};
        this.delayedLoadIds = 0;
    },
    checkDelayedLoads: function () {
        return _.map(this.delayedLoads, this.checkDelayedLoad, this);
    },
    checkDelayedLoad: function (args, delayedLoadId) {
        var els = args[0];
        var selector = args[1];
        var boundOnLoad = args[2];
        var timeoutTs = args[3];
        var lastLen = args[4];
        if (util.ts() < timeoutTs) {
            var len = els.find(selector).filter(function (i, e) {
                return $.contains(document, e);
            }).length;
            if (len > 0) {
                if (len != lastLen) {
                    lastLen = len;
                    args[4] = lastLen;
                    this.delayedLoads[delayedLoadId] = args;
                    return boundOnLoad;
                }
                return;
            }
        }
        this.unregisterDelayedLoad(delayedLoadId);
    },
    registerDelayedLoad: function (els, selector, boundOnLoad, timeout) {
        var timeoutTs = util.ts() + (timeout || 60000);
        this.delayedLoads[this.delayedLoadIds++] = [els, selector, boundOnLoad, timeoutTs];
        return boundOnLoad;
    },
    unregisterDelayedLoad: function (delayedLoadId) {
        delete this.delayedLoads[delayedLoadId];
    },
    doOembed: function (url, data, a, spin, checkLenLoad, options) {
        var oembedUrl;
        if (_.isFunction(options.oembedUrl)) {
            oembedUrl = options.oembedUrl(url, data);
        } else {
            oembedUrl = options.oembedUrl;
        }
        var ajaxOptions = {
            type: 'get',
            url: oembedUrl,
            cache: true,
            dataType: options.dataType || 'jsonp'
        };
        if (options.oembedData) {
            ajaxOptions.data = options.oembedData(url, data, a);
        }
        if (options.jsonp) {
            ajaxOptions.jsonp = options.jsonp;
        }
        this.buffer.session.ajax(ajaxOptions, options.filter)
            .done(_.bind(function (response) {
                return options.render(a, spin, url, response, data);
            }, this))
            .fail(_.bind(function () {
                spin.remove();
                $(a).addClass('error');
            }, this))
            .always(_.bind(function () {
                $(a).removeClass('loading');
                checkLenLoad();
            }, this));
    },
    loadOembed: function (els, initial, options) {
        var selector = 'a.' + options.className + '.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }

        var loaded = _.bind(this.triggerImagesLoaded, this, els, initial);
        var checkLenLoad = _.bind(function checkLenLoad () {
            --len;
            if (len === 0) {
                this.mediaLoaded(els, initial);
                loaded();
            }
        }, this);
        items.each(_.bind(function loadOembedEach (i, a) {
            var url = $(a).attr('href');
            var data = $(a).data();

            // Add a spinner
            var spin = this.makeSpin(url);
            $(a).closest('.content').append(spin);
            this.scroll.onChange();

            if (options.prefilter) {
                options.prefilter(url, data).done(_.bind(function (filteredData) {
                    this.doOembed(url, filteredData, a, spin, checkLenLoad, options);
                }, this)).fail(function () {
                    spin.remove();
                    $(a).addClass('error');
                    checkLenLoad();
                }).always(function () {
                    $(a).removeClass('loading');
                });
            } else {
                this.doOembed(url, data, a, spin, checkLenLoad, options);
            }
        }, this));

        return this;
    },
    buildFramePromise: function (
        url, maxSide, className, css,
        postMessageFilter, postMessageFilterTimeout,
        whitelistOrigin, onFrameLoad
    ) {
        var $iframe = $('<iframe class="loading">').addClass(className).attr(_.extend({
            'src': url
        }, this.formatter.linker.iframeProps())).css(_.extend({
            'width': maxSide,
            'height': 0,
            'visibility': 'hidden'
        }, css));
        var complete = new $.Deferred().done(_.bind(function (height) {
            $iframe.data('css', {
                'visibility': 'visible',
                'height': height
            });
            $iframe.addClass('loaded');
        }, this)).fail(function () {
            $iframe.addClass('error');
        }).always(function () {
            $iframe.removeClass('loading');
        });
        var whitelistId;
        if (whitelistOrigin) {
            whitelistId = this.buffer.session.postMessageTempWhitelist(whitelistOrigin);
        }
        $iframe.one('load', _.bind(function (e) {
            if (onFrameLoad) {
                onFrameLoad($iframe);
            }
            this.buffer.session.findMessage(function (event) {
                if (event.source !== $iframe[0].contentWindow) {
                    return false;
                }
                try {
                    var frameData = event.data;
                    if (typeof frameData === 'string') {
                        frameData = JSON.parse(frameData);
                    }
                    return postMessageFilter(frameData);
                } catch (exc) {
                    return null;
                }
            },
            postMessageFilterTimeout || 5000,
            whitelistId).done(_.bind(function (frameData) {
                complete.resolve(frameData);
            }, this)).fail(function () {
                complete.reject();
            });
        }, this));
        var promise = complete.promise();
        
        promise.iframe = $iframe;
        return promise;
    },
    buildGfycatFramePromise: function (gfycatId, width, height) {
        var url = 'https://gfycat.com/ifr/' +
            this.formatter.escapeText(encodeURIComponent(gfycatId));
        return this.buildFramePromise(url, width, 'gfycat', {}, function (frameData) {
            if (frameData.event == 'ready') {
                return height;
            }
            return null;
        });
    },
    buildInstagramFramePromise: function (embedId, embedType, maxSide) {
        var url = 'https://www.instagram.com/' + embedType + '/' +
            this.formatter.escapeText(encodeURIComponent(embedId)) +
            '/embed/captioned/?' +
            $.param({
                cr: 1,
                v: 7,
                wp: maxSide
            });
        return this.buildFramePromise(url, maxSide, 'instagram', {
            'border': '1px solid #ddd'
        }, function (frameData) {
            if (frameData.type == 'MEASURE' && frameData.details && frameData.details.height) {
                return frameData.details.height;
            }
            return null;
        });
    },
    buildMastodonFramePromise: function (origin, url, maxSide) {
        var embedUrl = url + '/embed';
        return this.buildFramePromise(embedUrl, maxSide, 'mastodon', {}, function (frameData) {
            if (frameData.type == 'setHeight' && frameData.height) {
                return frameData.height;
            }
            return null;
        }, 5000, origin, function ($iframe) {
            $iframe[0].contentWindow.postMessage({type: 'setHeight'}, '*');
        });
    },
    buildBskyFramePromise: function (did, post, maxSide) {
        var url = 'https://embed.bsky.app/embed/' + this.formatter.escapeText(did) + '/app.bsky.feed.post/' + this.formatter.escapeText(post);
        return this.buildFramePromise(url, maxSide, 'bsky', {}, function (frameData) {
            if (frameData.height) {
                return frameData.height;
            }
            return null;
        });
    },
    buildRedditFramePromise: function (sub, post, maxSide) {
        var theme = this.buffer.session.isLightTheme() ? '' : 'dark';
        var url = 'https://embed.reddit.com/r/' + this.formatter.escapeText(sub) +
            '/comments/' + this.formatter.escapeText(post) +
            '?' +
            $.param({
                embed: 'true',
                theme: theme
            });
        return this.buildFramePromise(url, maxSide, 'reddit', {}, function (frameData) {
            if (frameData.type == "resize.embed" && frameData.data) {
                return frameData.data;
            }
            return null;
        });
    },
    buildImgurFramePromise: function (embedId, maxSide) {
        var url = 'https://imgur.com/' +
            this.formatter.escapeTextMinimal(encodeURIComponent(embedId).replace(/%2f/gi, '/')) +
            '/embed?' +
            $.param({
                pub: true,
                ref: this.buffer.session.getOrigin(),
                w: maxSide
            });
        return this.buildFramePromise(url, maxSide, 'imgur', {
            'border': '1px solid #ddd'
        }, function (frameData) {
            if (frameData.message == 'resize_imgur') {
                return frameData.height;
            }
            return null;
        });
    },
    loadImgur: function (els, initial) {
        var selector = 'a.imgur.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }

        var imgurLoaded = this.loadMedia(els, selector, this.imgurLoaded, initial);
        items.each(_.bind(function (i, a) {
            var url = $(a).attr('href');
            var data = $(a).data();

            // Add a spinner
            var spin = this.makeSpin(url);
            $(a).closest('.content').append(spin);
            this.scroll.onChange();

            var imgurOembed = 'https://api.imgur.com/oembed.json?url=';
            var imgurRoot = 'https://imgur.com/';
            var imgurIRoot = 'https://i.imgur.com/';
            var ajaxOptions = {
                type: 'get',
                url: imgurOembed + encodeURIComponent(imgurRoot + data.imgur_embed_prefix + data.imgur_embed),
                cache: true,
                dataType: 'json'
            };
            var filter = function (response) {
                if (response.type == 'rich' && response.html) {
                    var oEmbed = $('<div>' + response.html + '</div>');
                    var embedId = oEmbed.find('blockquote.imgur-embed-pub').data('id');
                    if (embedId) {
                        return embedId;
                    }
                }
                return false;
            };

            var complete = $.Deferred()
                .done(_.bind(function (embedId) {
                    // Add to DOM
                    var maxSide = 390;
                    var framePromise = this.buildImgurFramePromise(embedId, maxSide);
                    this.loadIframe(framePromise, a, maxSide);
                    framePromise.always(_.bind(function () {
                        spin.remove();
                        --len;
                        if (len === 0) {
                            imgurLoaded();
                        }
                    }, this));
                }, this))
                .fail(_.bind(function () {
                    spin.remove();
                    $(a).addClass('error');
                    --len;
                    if (len === 0) {
                        imgurLoaded();
                    }
                }, this))
                .always(_.bind(function () {
                    $(a).removeClass('loading');
                }, this));
            var done = function (embedId) {
                complete.resolve(embedId);
            };
            this.buffer.session.ajax(ajaxOptions, filter).done(done)
                .fail(_.bind(function () {
                    if (data.imgur_embed_prefix) {
                        ajaxOptions.url = imgurOembed + encodeURIComponent(imgurRoot + data.imgur_embed);
                        this.buffer.session.ajax(ajaxOptions, filter).done(done)
                            .fail(_.bind(function () {
                                ajaxOptions.url = imgurOembed + encodeURIComponent(imgurIRoot + data.imgur_embed);
                                this.buffer.session.ajax(ajaxOptions, filter).done(done)
                                    .fail(_.bind(function () {
                                        complete.reject();
                                    }, this));
                            }, this));
                    } else {
                        ajaxOptions.url = imgurOembed + encodeURIComponent(imgurIRoot + data.imgur_embed);
                        this.buffer.session.ajax(ajaxOptions, filter).done(done)
                            .fail(_.bind(function () {
                                complete.reject();
                            }, this));
                    }
                }, this));
        }, this));
    },
    loadWiki: function (els, initial) {
        this.loadOembed(els, initial, {
            className: 'wiki',
            prefilter: _.bind(function (url, data) {
                var complete = $.Deferred();
                if (!this.loadWikiSpecialsPromise) {
                    // https://meta.wikimedia.org/w/api.php?action=help&modules=sitematrix
                    // https://meta.wikimedia.org/wiki/Special:SiteMatrix
                    this.loadWikiSpecialsPromise = this.buffer.session.ajax({
                        url: 'https://meta.wikimedia.org/w/api.php?action=sitematrix&format=json',
                        cache: true,
                        dataType: 'jsonp'
                    }, function (response) {
                        if (response) {
                            var map = {};
                            _.each(response.sitematrix, function (item, key) {
                                if (key == 'specials' && _.isArray(item)) {
                                    _.each(item, function (special) {
                                        if (!('closed' in special)) {
                                            map[special.url] = {
                                                name: special.sitename
                                            };
                                        }
                                    });
                                } else if (key.match(/^\d+$/) && _.isArray(item.site)) {
                                    _.each(item.site, function (site) {
                                        if (!('closed' in site)) {
                                            map[site.url] = {
                                                name: site.sitename,
                                                native_name: item.name,
                                                english_name: item.localname
                                            };
                                        }
                                    });
                                }
                            });
                            return map;
                        }
                        return false;
                    });
                }

                this.loadWikiSpecialsPromise.then(function (map) {
                    var wikiUrl = 'https://' + data.wiki_host;
                    var site = map[wikiUrl];
                    if (site) {
                        data.wiki_url = wikiUrl;
                        data.wiki_props = site;
                        complete.resolve(data);
                    } else {
                        complete.reject();
                    }
                }).fail(function () {
                    complete.reject();
                });
                return complete;
            }, this),
            dataType: 'jsonp',
            oembedUrl: function (url, data) {
                return data.wiki_url + '/w/api.php';
            },
            oembedData: function (url, data) {
                return {
                    action: 'query',
                    prop: 'imageinfo',
                    iiprop: 'url',
                    titles: data.wiki_title,
                    format: 'json'
                };
            },
            filter: function (response) {
                if (response && response.query && response.query.pages) {
                    for (var k in response.query.pages) {
                        if (response.query.pages[k].imageinfo && response.query.pages[k].imageinfo[0]) {
                            return response.query.pages[k];
                        }
                    }
                }
                return false;
            },
            render: _.bind(function (a, spin, url, response, data) {
                // Add to DOM
                var close, embed;
                var img = $('<img class="image loading">').attr({
                    src: urlUtil.toHttps(response.imageinfo[0].url),
                    alt: response.title
                });
                var imgLink = this.makeEmbedLink(url, img).attr('title', response.title);
                close = this.makeClose();
                embed = $('<span class="embedWrap">').append(imgLink, close);
                $(a).closest('.content').append(embed);
            }, this)
        });
    },
    makeClose: function (type) {
        type = type || 'image';
        return $('<a href="" class="embedClose">').attr('title', 'Close ' + type);
    },
    makeSpin: function (url) {
        return this.makeEmbedLink(url, this.formatter.embedSpin(), 'image spin');
    },
    makeEmbedLink: function (url, embed, className) {
        className = className || 'image';
        return this.makeLink(url, className)
            .attr('tabindex', '-1')
            .append(embed);
    },
    makeLink: function (url, className) {
        var link = $('<a rel="noreferrer" target="_blank">').attr('href', url);
        if (className) {
            link.addClass(className);
        }
        return link;
    },
    loadFlickr: function (els, initial) {
        return this.loadOembed(els, initial, {
            className: 'flickr',
            oembedUrl: 'https://www.flickr.com/services/oembed',
            oembedData: function (url) {
                return {
                    url: url,
                    format: 'json'
                };
            },
            dataType: 'jsonp',
            jsonp: 'jsoncallback',
            filter: function (response) {
                if (response) {
                    if (response.type == 'photo' && (response.url || response.thumbnail_url)) {
                        return true;
                    }
                    if (response.type == 'video' && response.html && response.width) {
                        return true;
                    }
                }
                return false;
            },
            render: _.bind(function (a, spin, url, response) {
                // Add to DOM
                var close, embed;
                if (response.type == 'photo') {
                    var photoUrl, photoHeight;
                    if (response.url) {
                        photoUrl = response.url;
                        photoHeight = response.height;
                    } else {
                        photoUrl = response.thumbnail_url;
                        photoHeight = response.thumbnail_height;
                    }
                    var img = $('<img class="image loading">').attr({
                        src: urlUtil.toHttps(photoUrl),
                        alt: response.title
                    });
                    var imgLink = this.makeEmbedLink(url, img).attr('title', response.title);
                    close = this.makeClose();
                    embed = $('<span class="embedWrap">').append(imgLink, close);
                    $(a).closest('.content').append(embed);
                } else {
                    spin.remove();
                    close = this.makeClose('video').css('left', response.width);
                    embed = $('<span class="embedWrap">').append(response.html.replace(/http:/g, 'https:'), close);
                    $(a).closest('.content').append(embed);
                    this.scroll.onChange();
                }
            }, this)
        });
    },
    loadSoundCloud: function (els, initial) {
        return this.loadOembed(els, initial, {
            className: 'soundcloud',
            oembedUrl: 'https://soundcloud.com/oembed.json',
            oembedData: function (url) {
                return {
                    url: url
                };
            },
            filter: function (response) {
                if (response && response.html) {
                    return true;
                }
                return false;
            },
            dataType: 'json',
            render: _.bind(function (a, spin, url, response) {
                // Add to DOM
                spin.remove();
                var urlParts = new window.URL(a.href);
                urlParts.hostname = urlParts.hostname.replace(/^www\./, '');
                var widgetSrc = 'https://w.soundcloud.com/player/?' + $.param({
                    url: urlParts.href,
                    color: 'ff5500',
                    auto_play: 'false',
                    hide_related: 'false',
                    show_comments: 'true',
                    show_artwork: 'false'
                });
                var html = $('<iframe class="video" width="416" height="116">').attr(_.extend({
                    'src': widgetSrc
                }, this.formatter.linker.iframeProps()));
                var close = this.makeClose().css('left', 416);
                var embed = $('<span class="embedWrap">').append(html, close);
                $(a).closest('.content').append(embed);
            }, this)
        });
    },
    loadStreamableCom: function (els, initial) {
        return this.loadOembed(els, initial, {
            className: 'streamablecom',
            oembedUrl: 'https://api.streamable.com/oembed.json',
            oembedData: function (url) {
                return {
                    url: url
                };
            },
            filter: function (response) {
                if (response.type == 'video' && response.html) {
                    var oEmbed = $('<div>' + response.html + '</div>');
                    var embedSrc = oEmbed.find('iframe.streamable-embed').attr('src');
                    if (embedSrc) {
                        return {
                            src: embedSrc.replace(/^http:/, 'https:'),
                            title: response.title
                        };
                    }
                }
                return false;
            },
            dataType: 'json',
            render: _.bind(function (a, spin, url, response) {
                // Add to DOM
                spin.remove();
                var iframe = $('<iframe class="video">').attr(_.extend({
                    'src': response.src,
                    'width': 416,
                    'height': 234
                }, this.formatter.linker.iframeProps()));
                var close = this.makeClose('video').css('left', 416);
                var embed = $('<span class="embedWrap">').append(iframe, close);
                $(a).closest('.content').append(embed);
            }, this)
        });
    },
    loadIframe: function (framePromise, a, maxSide) {
        var renderFrame = _.bind(function () {
            var embed = $('<span class="embedWrap">').append(framePromise.iframe);
            var close = this.makeClose('embed').css('left', maxSide);
            embed.append(close);
            $(a).closest('.content').append(embed);
            this.scroll.onChange();
        }, this);
        if (this.isSelected()) {
            renderFrame();
        } else {
            this.buffer.once('selectedChange', renderFrame);
        }
    },
    loadInstagram: function (els, initial) {
        var selector = 'a.instagram.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }

        var instagramLoaded = this.loadMedia(els, selector, this.instagramLoaded, initial);
        items.each(_.bind(function (i, a) {
            var url = $(a).attr('href');
            var data = $(a).data();

            // Add a spinner
            var spin = this.makeSpin(url);
            $(a).closest('.content').append(spin);
            this.scroll.onChange();

            // Add to DOM
            var maxSide = 390;
            var framePromise = this.buildInstagramFramePromise(
                data.photo_id, data.insta_type, maxSide
            );
            this.loadIframe(framePromise, a, maxSide);
            framePromise.always(_.bind(function () {
                spin.remove();
                $(a).removeClass('loading');
                --len;
                if (len === 0) {
                    instagramLoaded();
                }
            }, this));
        }, this));
    },
    loadMastodon: function (els, initial) {
        var selector = 'a.mastodon.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }

        var mastodonLoaded = this.loadMedia(els, selector, this.mastodonLoaded, initial);
        items.each(_.bind(function (i, a) {
            var url = $(a).attr('href');
            var data = $(a).data();

            // Add a spinner
            var spin = this.makeSpin(url);
            $(a).closest('.content').append(spin);
            this.scroll.onChange();

            var checkLenLoad = _.bind(function checkLenLoad () {
                spin.remove();
                $(a).removeClass('loading');
                --len;
                if (len === 0) {
                    mastodonLoaded();
                }
            }, this);

            // Add to DOM
            var maxSide = 500;
            var fetchUrl = data.mastodon_origin + '/api/v1/statuses/' + data.mastodon_status;
            fetch(fetchUrl).then(function (response) {
                return response.json();
            }).then(_.bind(function (apiData) {
                var userOrigin;
                if (data.mastodon_userinstance) {
                    userOrigin = 'https://' + data.mastodon_userinstance;
                } else {
                    userOrigin = data.mastodon_origin;
                }
                var userUrl = userOrigin + '/@' + data.mastodon_username;
                if (userUrl !== apiData.account.url) {
                    checkLenLoad();
                    return;
                }
                var urlParts = urlUtil.urlParts(apiData.url);
                if (urlParts.protocol !== 'https:') {
                    checkLenLoad();
                    return;
                }
                var framePromise = this.buildMastodonFramePromise(
                    urlParts.origin, urlParts.href, maxSide
                );

                var renderFrame = _.bind(function () {
                    var embed = $('<div class="mastodonwrap">').append(framePromise.iframe);
                    var close = this.makeClose('post').css('left', maxSide);
                    embed.append(close);
                    $(a).closest('.content').append(embed);
                    this.scroll.onChange();
                }, this);
                if (this.isSelected()) {
                    renderFrame();
                } else {
                    this.buffer.once('selectedChange', renderFrame);
                }
                
                framePromise.always(checkLenLoad);
            }, this)).catch(function () {
                checkLenLoad();
            });
        }, this));
    },
    loadBsky: function (els, initial) {
        var selector = 'a.bsky.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }

        var bskyLoaded = this.loadMedia(els, selector, this.bskyLoaded, initial);
        items.each(_.bind(function (i, a) {
            var url = $(a).attr('href');
            var data = $(a).data();

            // Add a spinner
            var spin = this.makeSpin(url);
            $(a).closest('.content').append(spin);
            this.scroll.onChange();

            var complete = $.Deferred()
                .done(_.bind(function (did) {
                    // Add to DOM
                    var maxSide = 500;
                    var framePromise = this.buildBskyFramePromise(did, data.bsky_post, maxSide);
                    var renderFrame = _.bind(function () {
                        framePromise.iframe.css('visibility', 'visible');
                        var embed = $('<div class="bskywrap">').append(framePromise.iframe);
                        var close = this.makeClose('post').css('left', maxSide);
                        embed.append(close);
                        $(a).closest('.content').append(embed);
                        this.scroll.onChange();
                    }, this);
                    if (this.isSelected()) {
                        renderFrame();
                    } else {
                        this.buffer.once('selectedChange', renderFrame);
                    }
                    framePromise.always(_.bind(function () {
                        spin.remove();
                        $(a).removeClass('loading');
                        --len;
                        if (len === 0) {
                            bskyLoaded();
                        }
                    }, this));
                }, this))
                .fail(_.bind(function () {
                    spin.remove();
                    $(a).addClass('error');
                    --len;
                    if (len === 0) {
                        bskyLoaded();
                    }
                }, this))
                .always(_.bind(function () {
                    $(a).removeClass('loading');
                }, this));
            var done = function (did) {
                complete.resolve(did);
            };

            if (data.bsky_did) {
                complete.resolve(data.bsky_did);
            } else if (data.bsky_handle) {
                var ajaxOptions = {
                    type: 'get',
                    url: 'https://public.api.bsky.app/xrpc/com.atproto.identity.resolveHandle?handle=' + encodeURIComponent(data.bsky_handle),
                    cache: true,
                    dataType: 'json'
                };
                var filter = function (response) {
                    return response.did || false;
                };
                this.buffer.session.ajax(ajaxOptions, filter).done(done)
                    .fail(_.bind(function () {
                        complete.reject();
                    }, this));
            } else {
                complete.reject();
            }
        }, this));
    },
    loadReddit: function (els, initial) {
        var selector = 'a.reddit.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }

        var redditLoaded = this.loadMedia(els, selector, this.redditLoaded, initial);
        items.each(_.bind(function (i, a) {
            var url = $(a).attr('href');
            var data = $(a).data();

            // Add a spinner
            var spin = this.makeSpin(url);
            $(a).closest('.content').append(spin);
            this.scroll.onChange();

            // Add to DOM
            var maxSide = 390;
            var framePromise = this.buildRedditFramePromise(
                data.reddit_sub, data.reddit_post, maxSide
            );
            var renderFrame = _.bind(function () {
                var embed = $('<div class="redditwrap">').append(framePromise.iframe);
                var close = this.makeClose('post').css('left', maxSide);
                embed.append(close);
                $(a).closest('.content').append(embed);
                this.scroll.onChange();
            }, this);
            if (this.isSelected()) {
                renderFrame();
            } else {
                this.buffer.once('selectedChange', renderFrame);
            }
            framePromise.always(_.bind(function () {
                spin.remove();
                $(a).removeClass('loading');
                --len;
                if (len === 0) {
                    redditLoaded();
                }
            }, this));
        }, this));
    },
    loadPinterest: function (els, initial) {
        return this.loadOembed(els, initial, {
            className: 'pinterest',
            dataType: 'jsonp',
            oembedUrl: 'https://api.pinterest.com/v3/pidgets/pins/info',
            oembedData: function (url, data) {
                return {
                    pin_ids: data.pin_id
                };
            },
            filter: function (response) {
                if (response) {
                    if (response.status === 'success' && response.data && response.data[0] && response.data[0].images && response.data[0].images['237x'] && !response.data[0].is_video) {
                        return true;
                    }
                }
                return false;
            },
            render: _.bind(function (a, spin, url, response) {
                // Add to DOM
                var photoUrl = response.data[0].images['237x'].url;
                var img = $('<img class="image loading">').attr({
                    src: photoUrl,
                    alt: response.data[0].description
                });
                var imgLink = this.makeEmbedLink(url, img).attr('title', response.data[0].description);
                var close = this.makeClose();
                var embed = $('<span class="embedWrap">').append(imgLink, close);
                $(a).closest('.content').append(embed);
            }, this)
        });
    },
    loadXKCD: function (els, initial) {
        return this.loadOembed(els, initial, {
            className: 'xkcd',
            dataType: 'jsonp',
            oembedUrl: function (url, data) {
                return 'https://dynamic.xkcd.com/api-0/jsonp/comic/' + encodeURIComponent(data.comic_id);
            },
            filter: function (response) {
                if (response) {
                    if (response.img) {
                        return true;
                    }
                }
                return false;
            },
            render: _.bind(function (a, spin, url, response) {
                // Add to DOM
                var photoUrl = response.img;
                var img = $('<img class="image loading">').attr({
                    src: photoUrl,
                    alt: response.alt
                });
                var imgLink = this.makeEmbedLink(url, img).attr('title', response.alt);
                var close = this.makeClose();
                var embed = $('<span class="embedWrap">').append(imgLink, close);
                $(a).closest('.content').append(embed);
            }, this)
        });
    },
    loadGfyCat: function (els, initial) {
        var selector = 'a.gfycat.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }

        var gfycatLoaded = this.loadMedia(els, selector, this.gfycatLoaded, initial);
        items.each(_.bind(function (i, a) {
            var url = $(a).attr('href');
            var data = $(a).data();

            // Add a spinner
            var spin = this.makeSpin(url);
            $(a).closest('.content').append(spin);
            this.scroll.onChange();

            // Add to DOM
            var width = 390;
            var height = 273;
            var framePromise = this.buildGfycatFramePromise(
                data.gfycat_id, width, height
            );
            this.loadIframe(framePromise, a, width);
            framePromise.always(_.bind(function () {
                spin.remove();
                $(a).removeClass('loading');
                --len;
                if (len === 0) {
                    gfycatLoaded();
                }
            }, this));
        }, this));
    },
    twitchEmotesLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {
            '.twitchEmote.imageLoaded': this.onImagesLoaded
        }, false);
    },
    loadTwitchEmotes: function (els, initial) {
        var done = this.loadMedia(els, '.twitchEmote.loading', this.twitchEmotesLoaded, initial);
        this.bindImageLoads(els, done);
        
        return this;
    },
    loadTwitchBadges: function (els, initial) {
        twitch.loadBadges(this.buffer.session, this.buffer.normalise(), els);
    },
    appendGist: function (appendTo, response, url, gist_hash) {
        // Process response div
        var gistDiv = $(response.div);
        // Make links open in a new tab
        gistDiv.find('a').each(function () {
            $(this).attr('target', '_blank');
            $(this).attr('rel', 'noreferrer');
        });

        // Only include first file or a named hash
        var foundFile = false;
        gistDiv.find('.gist-file').addClass('irccloud-to-remove');
        var selectedFile, selectedLine;
        if (gist_hash) {
            var lineMatch = gist_hash.match(/(^.*)-L(\d+)$/);
            var line;
            if (lineMatch) {
                gist_hash = lineMatch[1];
                line = lineMatch[2];
            }
            selectedFile = gistDiv.find('a').filter(function () {
                return this.hash == gist_hash;
            }).closest('.gist-file');
            if (selectedFile.length) {
                if (line) {
                    selectedLine = selectedFile.find(gist_hash + '-LC' + line);
                }
                foundFile = true;
            }
        }
        if (!foundFile) {
            selectedFile = gistDiv.find('.gist-file:first-child');
        }

        selectedFile.removeClass('irccloud-to-remove');
        var table = selectedFile.find('table.js-file-line-container');
        var rows = table.find('tbody tr');
        var truncated = table.find('tbody tr').slice(500);
        if (truncated.length) {
            truncated.remove();
            var fullLink = this.makeLink(url, 'irccloud-gist-truncated');
            fullLink.text('truncated… see full gist (' + rows.length.toLocaleString() + ' lines)');
            table.after(fullLink);
        }

        gistDiv.find('.irccloud-to-remove').remove();

        // remove footer
        // gistDiv.find('.gist-meta').remove();

        // remove line numbers
        // gistDiv.find('.line-numbers').remove();

        // Remove ids, might not be unique in page
        gistDiv.removeAttr('id');
        gistDiv.find('*').removeAttr('id');

        // Add to DOM
        appendTo.append(gistDiv);

        // Highlight and scroll to line
        if (selectedFile && selectedLine) {
            selectedLine.css({
                'background-color': 'rgb(255, 255, 204)'
            });
            selectedFile.find('.gist-data').scrollTop(selectedLine.position().top - selectedLine.height());
        }
    },
    buildGistTitle: function (response, url) {
        var title = $('<h1 class="gistwraptitle">');
        
        var close = '<span class="actions"><a href="" class="close">close</a></span>';
        title.append(close);

        var owner = this.makeLink('https://gist.github.com/' + encodeURIComponent(response.owner));
        owner.text(response.owner);
        title.append(owner);

        if (response.description) {
            title.append($('<span>').text(': ' + response.description));
        }

        var created = new Date(response.created_at);
        title.append(created.toString(" — d MMM yyyy "));

        if (response.files.length > 1) {
            title.append(this.makeLink(url).text(response.files.length + ' files…'));
        }
        return title;
    },
    getTwitterMeta: function () {
        // See <meta> here https://developer.x.com/en/docs/x-for-websites/embedded-tweets/overview
        var meta = {};
        $('meta[name]').each(_.bind(function (i, m) {
            var match = $(m).attr('name').match(/twitter:(.+)/);
            if (match) {
                meta[match[1]] = $(m).attr('content');
            }
        }, this));
        return meta;
    },
    loadTweets: function (els, initial) {
        if (!window.twttr) {
            return;
        }
        var selector = 'a.twitter.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }
        var twitterLoaded = this.loadMedia(els, selector, this.twitterLoaded, initial);
        
        var meta = this.getTwitterMeta();
        var tweetOpts = {
            // align: undefined,
            linkColor: meta['widgets:link-color'],
            // width: 'auto',
            theme: meta['widgets:theme'],
            // lang: 'en',
            dnt: true,
            conversation: 'all',
            cards: 'all'
        };
        if (!this.buffer.session.ent()) {
            tweetOpts.related = 'irccloud';
        }
        
        items.each(_.bind(function (i, a) {
            var moment_id = $(a).attr('data-twitter_moment_id');
            var tweet_id = $(a).attr('data-twitter_id');
            var widgetMethod, widgetArg;
            var thisOpts = _.clone(tweetOpts);
            var close = this.makeClose('tweet');
            var className = 'twitterwrap';
            if (tweet_id) {
                widgetMethod = 'createTweet';
                widgetArg = tweet_id;
            } else if (moment_id) {
                widgetMethod = 'createMoment';
                widgetArg = moment_id;
                thisOpts.limit = 1;
                thisOpts.width = 500;
                close.attr('title', 'Close moment');
                className += ' twitterwrap--moment';
            } else {
                // formatter.renderLinkifyProcessor can delete data that's already been
                // seen in a line
                --len;
                if (len === 0) {
                    twitterLoaded();
                }
                return;
            }

            var wrapper = $('<div>').addClass(className);
            $(a).closest('.content').append(wrapper);
            var complete = $.Deferred().done(_.bind(function (widget, params) {
                wrapper.addClass('loaded');
                wrapper.append(close);
            }, this)).fail(function () {
                wrapper.remove();
                $(a).addClass('error');
            }).always(function () {
                $(a).removeClass('loading');
                --len;
                if (len === 0) {
                    twitterLoaded();
                }
            });

            window.twttr.ready(_.bind(function (twttr) {
                twttr.widgets[widgetMethod](widgetArg, wrapper[0], thisOpts).then(
                    _.bind(function (widget) {
                        this.tweetEmbedLoaded(widget, complete);
                    }, this)
                );
            }, this));
        }, this));

        return this;
    },

    // message.data: {
    //     'twttr.embed': {
    //         id: "twitter-widget-0"
    //         jsonrpc: "2.0"
    //         method: "twttr.private.resize"
    //         params: [{
    //             width: 550,
    //             height: 842,
    //             data: {
    //                 tweet_id: '1234567890'
    //             }
    //         }]
    //     }
    // }
    findTwitterPostMessage: function (tweetFrameWindow, type) {
        return this.buffer.session.findMessage(_.bind(function (message) {
            if (message.source !== tweetFrameWindow) {
                return false;
            }
            if (
                'twttr.embed' in message.data &&
                message.data['twttr.embed'].method == type
            ) {
                return message.data['twttr.embed'];
            }
            return null;
        }, this), 5000);
    },
    tweetEmbedLoaded: function (widget, complete) {
        if (widget) {
            var tweetFrameWindow = $(widget).find('iframe')[0].contentWindow;
            this.findTwitterPostMessage(tweetFrameWindow, 'twttr.private.rendered')
                .done(function (data) {
                    complete.resolve(widget, data);
                })
                .fail(function () {
                    complete.reject();
                });
        } else {
            complete.reject();
        }
    },
    loadGists: function (els, initial) {
        var selector = 'a.gist.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }
        var gistsLoaded = this.loadMedia(els, selector, this.gistsLoaded, initial);

        items.each(_.bind(function (i, a) {
            var gist_id = $(a).data('gist_id');
            var gist_hash = $(a).data('gist_hash');
            var url = 'https://gist.github.com/';
            url += encodeURIComponent(gist_id);
            var jsonUrl = url + '.json';
            var complete = $.Deferred();
            this.buffer.session.ajax({
                url: jsonUrl,
                cache: true,
                dataType: 'jsonp'
            }, function (response) {
                return !!response;
            }).then(_.bind(function (response) {
                var title = this.buildGistTitle(response, url);
                var gistWrap = $('<div class="gistwrap loaded">');
                gistWrap.append(title);

                var iframe = $('<iframe>').attr(this.formatter.linker.iframeProps()).css({
                    'width': '100%',
                    'height': 190,
                    'overflow': 'hidden'
                });

                gistWrap.append(iframe);
                $(a).closest('.content').append(gistWrap);

                // Add doctype after adding to DOM
                var idocument = iframe[0].contentDocument;
                // Iframe might have been removed from the dom in the mean time
                if (!idocument) {
                    return;
                }
                idocument.open();
                idocument.write("<!DOCTYPE html>");
                idocument.close();

                // Load CSS
                var cssToLoad = 2;
                var cssComplete = new $.Deferred().progress(function () {
                    if (!--cssToLoad) {
                        cssComplete.resolve();
                    }
                });
                var externalCSS = $('<link rel="stylesheet">').attr('href', response.stylesheet).one('load', function () {
                    cssComplete.notify();
                });
                var overrideCSS = $('<link rel="stylesheet">').attr('href', '/static/gist.css').one('load', function () {
                    cssComplete.notify();
                });
                // Resize on load to avoid scrollbars
                cssComplete.done(function () {
                    setTimeout(function () {
                        var gistHeight = iframe.contents().find('.gist .gist-data>div').height();
                        if (gistHeight && gistHeight < 163) {
                            iframe.css('height', gistHeight + 27);
                            setTimeout(function () {
                                iframe.css('height', gistHeight + 28);
                            });
                        } else {
                            iframe.css('height', 195);
                        }
                    });
                });
                // Add CSS
                iframe.contents().find('head').append(externalCSS).append(overrideCSS);
                // Add gist content
                this.appendGist(iframe.contents().find('body'), response, url, gist_hash);
                complete.resolve();
                return complete.promise();
            }, this)).fail(function () {
                $(a).addClass('error');
            }).always(function () {
                $(a).removeClass('loading');
                --len;
                if (len === 0) {
                    gistsLoaded();
                }
            });
        }, this));

        return this;
    },
    loadFiles: function (els, initial, reqid) {
        var selector = 'a.file.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }
        if (!this.buffer.inlineFilesAllowed()) {
            els.removeClass('fileLoading');
            if (reqid) {
                var pending = this.getPendingRow(reqid);
                pending.remove();
            }
            return;
        }
        
        var loaded = this.loadMedia(els, selector, this.filesLoaded, initial, reqid);
        
        var checkLenLoad = function () {
            --len;
            if (len === 0) {
                loaded();
            }
        };
        items.each(_.bind(function (i, a) {
            var fileData = $(a).data();
            var f = new FileWrapper(fileData, {
                session: this.buffer.session
            });
            var fv = new FileInlineView({model: f});
            fv.bind('toggleEdit', function () {
                this.scroll.onChange();
            }, this);
            fv.bind('collapsed', function () {
                this.scroll.onChange();
            }, this);
            var wrap = $(a).closest('span.fileWrap');
            f.fetch()
                .fail(_.bind(function () {
                    wrap.remove();
                    checkLenLoad();
                }, this))
                .done(_.bind(function () {
                    if (f.isDeleted()) {
                        wrap.remove();
                        checkLenLoad();
                    } else {
                        $(a).removeClass('loading').addClass('loaded');
                        var renderPreview = _.bind(function () {
                            // Only on individual messages (not initial)
                            // Need to show the line briefly to
                            // calculate dimensions
                            if (!initial) {
                                els.removeClass('fileLoading');
                            }
                            var preview = fv.render(wrap).el;
                            if (!initial) {
                                els.addClass('fileLoading');
                            }
                            wrap.removeClass('loading').addClass('loaded');
                            wrap.append(preview);
                            _.each(fv.$('.filePreviewImageDummy'), this.setEmbedClosePosition, this);
                            checkLenLoad();
                        }, this);
                        if (this.isSelected()) {
                            renderPreview();
                        } else {
                            this.buffer.once('selectedChange', renderPreview);
                        }
                    }
                }, this));
        }, this));

        return this;
    },

    fileWrapsLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {
            'a.file.loaded': function (els, loaded, animate) {
                loaded.each(_.bind(function (i, a) {
                    $(a).closest('span.fileWrap').removeClass('loaded').addClass('rendered');
                    $(a).remove();
                }, this));
            }
        });
    },
    fileImagesLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {
            'img.imageLoaded': this.onImagesLoaded,
            '.mediaLoaded': this.onMediaLoaded
        });
    },
    filesLoaded: function (els, initial, reqid) {
        var fileWrapsDone = this.loadMedia(els, 'span.fileWrap.loaded', this.fileWrapsLoaded, initial);
        
        var complete = new $.Deferred().done(_.bind(function () {
            if (!initial) {
                // Only on individual messages (not initial)
                // whole line hidden until loaded
                els.removeClass('fileLoading');
                // Recalculate close position after message
                // is revealed
                _.each(els.find('img.imageRendered, .mediaRendered'), this.setEmbedClosePosition, this);
            }
            fileWrapsDone();
        }, this));
        if (reqid) {
            var pending = this.getPendingRow(reqid);
            pending.addClass('pendingOut');
            // pendingOut class takes a short while to animate out
            // remove it from the DOM after the animation
            setTimeout(_.bind(function () {
                pending.remove();
                complete.resolve();
            }, this), 200);
        } else {
            complete.resolve();
        }
        
        var fileImagesDone = this.loadMedia(els, 'span.fileWrap.loaded', this.fileImagesLoaded, initial);
        var len = 2;
        var fileImagesComplete = new $.Deferred()
            .done(fileImagesDone)
            .progress(function () {
                --len;
                if (len === 0) {
                    fileImagesComplete.resolve();
                }
            });
        function fileImagesNotify () {
            fileImagesComplete.notify();
        }
        this.bindImageLoads(els, fileImagesNotify);
        this.bindMediaLoads(els, fileImagesNotify);
    },
    loadAttachmentSnippets: function (els, initial) {
        var selector = '.attachment__snippet';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }

        var attachSnippetsLoaded = this.loadMedia(els, selector, this.attachSnippetsLoaded, initial);

        items.each(_.bind(function (i, el) {
            var $item = $(el);

            if (!this.buffer.inlinePastesAllowed()) {
                this.hideEmbed($item);
                return;
            }
            if ($item.closest('.content').find('.entityWrap').length) {
                return;
            }

            var pData = $item.data();
            var paste = {
                body: $item.text(),
                name: pData.filename,
                external_url: pData.url,
                external_raw_url: pData.raw_url,
                service_name: pData.service_name,
                service_url: pData.service_url,
                lines: pData.lines,
                date: pData.ts,
                size: pData.size
            };
            if (pData.lines && pData.lines > pData.preview_lines) {
                paste.truncated_lines = pData.preview_lines;
                paste.truncated = true;
            }
            var pbv = PastebinView.fromPaste(paste, this.buffer.session);
            if (pData.name) {
                pbv.model.set('name', pData.name);
            }
            pbv.bind('editorResize', function () {
                this.scroll.onChange();
            }, this);
            pbv.render({header: true, withClose: true});
            var wrap = $('<span class="entityWrap">');
            $item.closest('.content').append(wrap.append(pbv.el));
            pbv.once('rendered', function () {
                var attachWrap = $item.closest('.attachWrap').hide();
                wrap.addClass('loaded');
                --len;
                if (len === 0) {
                    attachSnippetsLoaded();
                }
            }, this);
        }, this));

        return this;
    },
    loadPastes: function (els, initial) {
        var selector = 'a.paste.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }
        var pastesLoaded = this.loadMedia(els, selector, this.pastesLoaded, initial);

        items.each(_.bind(function (i, a) {
            var pData = $(a).data();
            var paste = {};
            for (var k in pData) {
                if (k.indexOf('paste_') === 0) {
                    paste[k.replace(/^paste_/, '')] = pData[k];
                }
            }
            if (paste.id) {
                var pbv = PastebinView.fromPaste(paste, this.buffer.session);
                pbv.bind('toggleEdit', function () {
                    this.scroll.onChange();
                }, this);
                pbv.bind('editorResize', function () {
                    this.scroll.onChange();
                }, this);
                pbv.model.bind('removed', function () {
                    this.scroll.onChange();
                }, this);
                pbv.model.fetch().always(_.bind(function () {
                    if (pbv.model.get('body')) {
                        pbv.render({header: true, withClose: true});
                        var wrap = $('<span class="entityWrap">');
                        $(a).closest('.content').append(wrap.append(pbv.el));
                        pbv.once('rendered', function () {
                            wrap.addClass('loaded');
                            $(a).removeClass('loading');
                            --len;
                            if (len === 0) {
                                pastesLoaded();
                            }
                        }, this);
                    } else {
                        $(a).removeClass('loading');
                        --len;
                        if (len === 0) {
                            pastesLoaded();
                        }
                    }
                }, this));
            } else {
                $(a).removeClass('loading');
                --len;
                if (len === 0) {
                    pastesLoaded();
                }
            }
        }, this));

        return this;
    },
    bindMediaLoads: function (els, done) {
        var selector = '.media.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            done();
            return;
        }
        var complete = new $.Deferred();
        complete.progress(function () {
            --len;
            if (len === 0) {
                complete.resolve();
            }
        });
        complete.done(done);
        items.each(function (i, media) {
            var $media = $(media);
            $media.one('loadedmetadata', function (e) {
                $media.removeClass('loading').addClass('mediaLoaded');
                complete.notify('load', media);
            });
            $media.one('error', function (e) {
                $media.removeClass('loading').addClass('mediaError');
                complete.notify('error', media);
            });
        });
        return complete.promise();
    },
    bindImageLoads: function (els, done) {
        var selector = 'img.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            done();
            return;
        }

        // create an observer instance
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.removedNodes) {
                    _.each(mutation.removedNodes, function (node) {
                        items.each(function (i, item) {
                            if ($.contains(node, item)) {
                                complete.notify('removed', item);
                            }
                        });
                    });
                }
            });    
        });
        observer.observe(this.el, { childList: true, subtree: true });

        var complete = new $.Deferred();
        complete.progress(function bindImageLoadsProgress () {
            --len;
            if (len === 0) {
                observer.disconnect();
                complete.resolve();
            }
        });

        complete.done(done);
        items.each(function bindImageLoadsEach (i, img) {
            var $img = $(img);
            function imgOnLoad () {
                $img.removeClass('loading').addClass('imageLoaded');
                complete.notify('load', img);
            }
            function imgOnError (e) {
                $img.removeClass('loading').addClass('imageError');
                complete.notify('error', img);
            }
            if (img.complete) {
                imgOnLoad();
            } else {
                if (img.complete === undefined) {
                    // cached images don't fire load sometimes, so we reset src.
                    var src = img.src;
                    // webkit hack from https://groups.google.com/group/jquery-dev/browse_thread/thread/eee6ab7b2da50e1f
                    // data uri bypasses webkit log warning (thx doug jones)
                    img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
                    img.src = src;
                }
                $img.one('load', imgOnLoad);
                $img.one('error', imgOnError);
            }
        });
        return complete.promise();
    },
    triggerImagesLoaded: function (els, initial) {
        var done = this.loadMedia(els, 'img.loading', this.imagesLoaded, initial);
        this.bindImageLoads(els, done);
        
        return this;
    },
    loadEmbedIframes: function (els, initial) {
        var selector = 'iframe.iframeEmbed';
        var items = els.find(selector);
        items.each(_.bind(function (i, iframe) {
            $(iframe).one('load', _.bind(function (e) {
                this.setEmbedClosePositionOnceSelected(iframe);
            }, this));
        }, this));
    },
    mediaLoaded: function (els, initial, loadedMap, animate) {
        this.scroll.checkPinBottom(function (pinBottom) {
            var promise = new $.Deferred();
            if (loadedMap) {
                var mapLen = _.size(loadedMap);
                promise.progress(function mediaLoadedProgress () {
                    if (!--mapLen) {
                        promise.resolve();
                    }
                });
                _.each(loadedMap, _.bind(function mediaLoadedEach (processLoaded, loadedSelector) {
                    var loaded = els.find(loadedSelector);
                    // Only animate after first run and if any loaded
                    if (animate === undefined) {
                        animate = !initial && !!loaded.length;
                    }
                    var result = _.bind(processLoaded, this)(els, loaded, animate);
                    if (result) {
                        result.done(_.bind(function mediaLoadedEachDone () {
                            promise.notify();
                        }, this));
                    } else {
                        promise.notify();
                    }
                }, this));
            } else {
                promise.resolve();
            }
            return promise.promise().done(_.bind(function mediaLoadedDone () {
                // Update scroll
                this.scroll.onChange(pinBottom, animate);
            }, this));
        }, this);
    },
    gistsLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {'div.gistwrap.loaded': function (els, loaded, animate) {
            loaded.removeClass('loaded').addClass('rendered');
        }});
    },
    instagramLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {'iframe.instagram.loaded': function (els, loaded, animate) {
            loaded.each(_.bind(function (i, iframe) {
                var css = $(iframe).data('css');
                $(iframe).css(css).removeClass('loaded').addClass('rendered');
            }, this));
        }});
    },
    mastodonLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {'iframe.mastodon.loaded': function (els, loaded, animate) {
            loaded.each(_.bind(function (i, iframe) {
                var css = $(iframe).data('css');
                $(iframe).removeAttr('scrolling');
                $(iframe).css(css).removeClass('loaded').addClass('rendered');
            }, this));
        }});
    },
    redditLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {'iframe.reddit.loaded': function (els, loaded, animate) {
            loaded.each(_.bind(function (i, iframe) {
                var css = $(iframe).data('css');
                $(iframe).css(css).removeClass('loaded').addClass('rendered');
            }, this));
        }});
    },
    bskyLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {'iframe.bsky.loaded': function (els, loaded, animate) {
            loaded.each(_.bind(function (i, iframe) {
                var css = $(iframe).data('css');
                $(iframe).css(css).removeClass('loaded').addClass('rendered');
            }, this));
        }});
    },
    gfycatLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {'iframe.gfycat.loaded': function (els, loaded, animate) {
            loaded.each(_.bind(function (i, iframe) {
                var css = $(iframe).data('css');
                $(iframe).css(css).removeClass('loaded').addClass('rendered');
            }, this));
        }});
    },
    imgurLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {'iframe.imgur.loaded': function (els, loaded, animate) {
            loaded.each(_.bind(function (i, iframe) {
                var css = $(iframe).data('css');
                $(iframe).css(css).removeClass('loaded').addClass('rendered');
            }, this));
        }});
    },
    twitterLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {'div.twitterwrap.loaded': function (els, loaded, animate) {
            loaded.each(_.bind(function (i, div) {
                $(div).removeClass('loaded').addClass('rendered');
                var widget = $(div).find('iframe');
                this.setEmbedClosePositionOnceSelected(widget[0]);
                if (widget[0]) {
                    var tweetFrameWindow = widget[0].contentWindow;
                    this.findTwitterPostMessage(tweetFrameWindow, 'twttr.private.resize').done(
                        _.bind(function () {
                            this.scroll.onChange();
                        }, this)
                    );
                }
            }, this));
        }});
    },
    pastesLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {'span.entityWrap.loaded': function (els, loaded, animate) {
            loaded.removeClass('loaded').addClass('rendered');
        }});
    },
    attachSnippetsLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {'span.entityWrap.loaded': function (els, loaded, animate) {
            loaded.removeClass('loaded').addClass('rendered');
        }});
    },
    onMediaLoaded: function (els, loaded, animate) {
        loaded.each(_.bind(function onMediaLoadedEach (i, media) {
            var $media = $(media);
            $media.closest('.content').find('a.spin').remove();
            $media.removeClass('mediaLoaded');
            $media.addClass('mediaRendered');
            this.setEmbedClosePositionOnceSelected(media);
        }, this));
        // Hide errored
        var errored = els.find('.mediaError');
        errored.each(_.bind(function onMediaLoadedErrorEach (i, media) {
            var $media = $(media);
            $media.closest('.content').find('a.spin').remove();
            $media.closest('.mediaPreview')
                .removeClass('mediaPreview')
                .addClass('docPreview')
                .find('a.embedClose').remove();
            $media.remove();
        }, this));

        if (animate) {
            loaded.animate({opacity: 1}, 'slow');
        } else {
            loaded.css('opacity', 1);
        }
    },
    onImagesLoaded: function (els, loaded, animate) {
        loaded.each(_.bind(function onImagesLoadedEach (i, img) {
            var $img = $(img);
            $img.closest('.content').find('a.spin').remove();
            $img.closest('.content').find('.filePreviewImageDummy').remove();
            $img.removeClass('imageLoaded');
            $img.addClass('imageRendered');
            var closeAble = !$img.is('.notCloseable');
            if (closeAble) {
                this.setEmbedClosePositionOnceSelected(img);
            }
        }, this));
        // Hide errored
        var errored = els.find('img.imageError');
        errored.each(_.bind(function onImagesLoadedErrorEach (i, img) {
            var $img = $(img);
            $img.closest('.content').find('a.spin').remove();
            if ($img.closest('.attachWrap').length) {
                $img.remove();
            } else {
                this.hideEmbed($img);
            }
        }, this));

        if (animate) {
            loaded.animate({opacity: 1}, 'slow');
        } else {
            loaded.css('opacity', 1);
        }
    },
    imagesLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {
            'img.imageLoaded': this.onImagesLoaded
        });
    },
    setEmbedClosePositionOnceSelected: function (el) {
        if (this.isSelected()) {
            this.setEmbedClosePosition(el);
        } else {
            this.buffer.once('selectedChange', function () {
                this.setEmbedClosePosition(el);
            }, this);
        }
    },
    setEmbedClosePosition: function (el) {
        if (!el) {
            return;
        }
        $(el).closest('.directEmbedWrap, .embedWrap, .mastodonwrap, .bskywrap, .redditwrap, .twitterwrap, .fbwrap, .fileWrap').find('.embedClose').css('left', el.clientWidth + $(el).position().left);
    },
    resetEmbedClosePositions: function () {
        _.each(this.$('img.imageRendered, .mediaRendered, .mastodonwrap.rendered, .bskywrap.rendered, .redditwrap.rendered, .twitterwrap.rendered iframe, .fbwrap.rendered iframe, .directEmbedWrap iframe.iframeEmbed'), this.setEmbedClosePosition, this);
    },
    showAttachmentFallback: function (target) {
        var attachFallback = target.closest('.content').find('.attachFallback');
        if (attachFallback.length) {
            attachFallback.addClass('attachFallback--show');
        }
    },
    hideEmbed: function (target) {
        var fileWrap = target.closest('.fileWrap');
        if (fileWrap.length) {
            fileWrap.find('a.fileClose').click();
        } else {
            var attachWrap = target.closest('.attachWrap');
            if (attachWrap.length) {
                this.showAttachmentFallback(target);
                attachWrap.hide();
            } else {
                var embed = target.closest('.directEmbedWrap, .embedWrap, .mastodonwrap, .bskywrap, .redditwrap, .twitterwrap, .fbwrap, .gistwrap');
                embed.prev('.spin').remove();
                embed.remove();
            }
        }
    },
    clickEmbedClose: function (e) {
        e.preventDefault();
        this.hideEmbed($(e.target));
        this.scroll.onChange();
    },
    clickPasteClose: function (e) {
        // TODO move to pastebinview
        e.preventDefault();
        var target = $(e.target);
        var pasteDiv = target.closest('div.paste');
        var pastebin = PastebinView.fromEl(pasteDiv, this.buffer.session);
        this.showAttachmentFallback(target);
        pastebin.collapse(true);
        this.scroll.onChange();
    }
});

module.exports = BufferLogContainerView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/bufferlogcontainerview.js
// module id = Qc6Z
// module chunks = 1